import store from "../redux/store";
import CartOperationManager from "./CartOperationManager";
import {
  setCart,
  completeLocationUpdate,
  completeFeeCalculation,
  completeDateUpdate,
  completeItemUpdate,
} from "../redux/cartReducer";

/**
 * Sets up event listeners for the CartOperationManager
 * This allows automatic state updates when operations complete
 */
class CartOperationEventHandler {
  static initialize() {
    // Listen for operation completions
    CartOperationManager.on("operation:completed", ({ operation, result }) => {
      console.log(
        `[OperationEvent] Operation completed: ${operation.type} (${operation.id})`
      );

      const { dispatch } = store;

      // Update state based on operation type
      switch (operation.type) {
        case "LOCATION_UPDATE":
          dispatch(completeLocationUpdate());

          // Update cart with result if available
          if (result?.cart) {
            dispatch(setCart(result.cart));
          }
          break;

        case "QUANTITY_UPDATE":
          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );

            // Also complete fee calculation
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }
          break;

        case "DATE_UPDATE":
          if (operation.groupIds?.length) {
            dispatch(completeDateUpdate(operation.groupIds[0]));
          }
          break;

        case "ITEM_REMOVAL":
          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );

            // Also complete fee calculation
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }
          break;
      }
    });

    // Listen for operation failures
    CartOperationManager.on("operation:failed", ({ operation, error }) => {
      console.error(
        `[OperationEvent] Operation failed: ${operation.type} (${operation.id})`,
        error
      );

      const { dispatch } = store;

      // Handle failure based on operation type
      switch (operation.type) {
        case "LOCATION_UPDATE":
          dispatch(completeLocationUpdate());
          break;

        case "QUANTITY_UPDATE":
        case "ITEM_REMOVAL":
          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }
          break;

        case "DATE_UPDATE":
          if (operation.groupIds?.length) {
            dispatch(completeDateUpdate(operation.groupIds[0]));
          }
          break;
      }
    });
  }
}

export default CartOperationEventHandler;
